module.exports = __webpack_public_path__ + "static/img/cover-image-1.9b201b3.png";